import React, { useCallback, useContext, useEffect, useState } from 'react';
import './UserInfo.css';
import { personValidator } from '../../service/validatorForms';
import MainContext from '../../context/mainContext';
import { updateUserInfo } from '../../service/userService';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import IconLoading from '../shared/IconLoading';
import { charsNormalize } from '../../util/charactorsNormalize';

const UserInfo = () => {

    const context = useContext(MainContext)
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [mobile, setMobile] = useState('');
    const [mobile1, setMobile1] = useState('');
    const [mobile2, setMobile2] = useState('');
    const [tel, setTel] = useState('');
    const [tel1, setTel1] = useState('');
    const [validator] = useState(personValidator());
    const [, setForceUpdate] = useState();
    const forceUpdate = useCallback(() => setForceUpdate({}), []);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!context.loggedIn)
            return;
        setName(context.loggedIn.name || '')
        setAddress(context.loggedIn.address || '')
        setMobile(context.loggedIn.mobile || '')
        setMobile1(context.loggedIn.mobile1 || '')
        setMobile2(context.loggedIn.mobile2 || '')
        setTel(context.loggedIn.phone || '')
        setTel1(context.loggedIn.phone1 || '')
    }, [context.loggedIn])

    const submitUserInfoHandler = async (event) => {
        try {
            event.preventDefault();
            if (validator.allValid()) {
                setIsLoading(true);
                let info = {
                    userId: context.loggedIn._id,
                    mobile1: mobile1,
                    mobile2: mobile2,
                    phone: tel,
                    phone1: tel1,
                    address: address,
                    name: name
                }

                const { status, data } = await updateUserInfo(info);
                if (status === 201) {
                    toast.success('ویرایش اطلاعات با موفقیت انجام شد')
                    setIsLoading(false);
                    window.innerWidth >= 992 ? navigate('/') : navigate('/account-menu');
                    context.login({ ...context.loggedIn, ...data.newInfo })
                }
            } else {
                validator.showMessages();
                toast.error('خطاها را رفع کنید')
                forceUpdate();
            }



        } catch (err) {
            if (err.response && err.response.status === 401) {
                toast.error('عدم دسترسی مجاز');
                navigate('/', { replace: true });
            }
            else if (err.response && err.response.status === 404) {
                toast.error('کاربر مورد نظر یافت نشد');

            }
            setIsLoading(false);
        }
    }

    const getInvalidClass = (field) => {
        return (!validator.fieldValid(field) && validator.messagesShown) ? 'invalid_input' : ''
    }

    return (
        <div>
            <form
                style={{ fontSize: ".9rem" }}
                className="row g-2 mt-2"
                onSubmit={submitUserInfoHandler}
            >
                <div className="col-12" >
                    <h6>ویرایش اطلاعات</h6>
                </div>
                <div className="col-12 col-sm-4">
                    <div className="form-floating">
                        <input
                            type="text"
                            autoComplete='off'
                            className={`form-control  ${getInvalidClass('mobile')} ltr`}
                            id="mobile"
                            placeholder='موبایل'
                            value={mobile}
                            onChange={e => {
                                setMobile(charsNormalize(e.target.value));
                                setTimeout(() => forceUpdate(), 10)
                            }}
                            disabled={true}
                        />
                        <label htmlFor="mobile"><i className="fa fa-mobile me-2"></i>موبایل</label>
                    </div>
                    {validator.message("mobile", mobile, "phone")}
                </div>
                <div className="col-12 col-sm-4" >
                    <div className="form-floating">
                        <input
                            type="text"
                            autoComplete='off'
                            className={`form-control  ${getInvalidClass('name')}`}
                            id="user_name"
                            placeholder="نام و نام خانوادگی"
                            value={name}
                            onChange={e => {

                                setName(charsNormalize(e.target.value));
                                setTimeout(() => forceUpdate(), 10)
                            }}
                        />
                        <label htmlFor="user_name">نام و نام خانوادگی</label>
                    </div>
                    {validator.message("name", name, "required|max:55")}
                </div>
                <div className="col-12 col-sm-4">
                    <div className="form-floating">
                        <input
                            type="text"
                            autoComplete='off'
                            className={`form-control  ${getInvalidClass('mobile1')} ltr`}
                            id="mobile1"
                            placeholder='موبایل 2'
                            value={mobile1}
                            onChange={e => {

                                setMobile1(charsNormalize(e.target.value));
                                setTimeout(() => forceUpdate(), 10)
                            }}
                        />
                        <label htmlFor="mobile1"><i className="fa fa-mobile1 me-2"></i>موبایل 2</label>
                    </div>
                    {validator.message("mobile1", mobile1, "phone")}
                </div>
                <div className="col-12 col-sm-4">
                    <div className="form-floating">
                        <input
                            type="text"
                            autoComplete='off'
                            className={`form-control  ${getInvalidClass('mobile2')} ltr`}
                            id="mobile2"
                            placeholder='موبایل 3'
                            value={mobile2}
                            onChange={e => {

                                setMobile2(charsNormalize(e.target.value));
                                setTimeout(() => forceUpdate(), 10)
                            }}
                        />
                        <label htmlFor="mobile2"><i className="fa fa-mobile2 me-2"></i>موبایل 3</label>
                    </div>
                    {validator.message("mobile2", mobile2, "phone")}
                </div>
                <div className="col-12 col-sm-4">
                    <div className="form-floating">
                        <input
                            type="text"
                            autoComplete='off'
                            className={`form-control  ${getInvalidClass('tel')} ltr`}
                            id="tel"
                            placeholder='تلفن'
                            value={tel}
                            onChange={e => {

                                setTel(charsNormalize(e.target.value));
                                setTimeout(() => forceUpdate(), 10)
                            }}
                        />
                        <label htmlFor="tel"><i className="fa fa-phone me-2"></i>تلفن</label>
                    </div>
                    {validator.message("tel", tel, "phone")}
                </div>
                <div className="col-12 col-sm-4">
                    <div className="form-floating">
                        <input
                            type="text"
                            autoComplete='off'
                            className={`form-control  ${getInvalidClass('tel1')} ltr`}
                            id="tel1"
                            placeholder='تلفن 2'
                            value={tel1}
                            onChange={e => {

                                setTel1(charsNormalize(e.target.value));
                                setTimeout(() => forceUpdate(), 10)
                            }}
                        />
                        <label htmlFor="tel1"><i className="fa fa-phone me-2"></i>تلفن 2</label>
                    </div>
                    {validator.message("tel1", tel1, "phone")}
                </div>
                <div className="col-12">
                    <div className="form-floating">
                        <input
                            type="text"
                            autoComplete='off'
                            className={`form-control  ${getInvalidClass('address')}`}
                            id="address"
                            placeholder="آدرس"
                            value={address}
                            onChange={e => {

                                setAddress(charsNormalize(e.target.value));
                                setTimeout(() => forceUpdate(), 10)
                            }}
                        />
                        <label htmlFor="address"><i className="fa fa-map-marker me-2"></i>آدرس</label>
                    </div>
                    {validator.message("address", address, "required|max:255")}
                </div>
                <div className="col-12 text-center my-4">
                    <button
                        className="btn btn-success"
                        type="submit"
                        style={{ width: "150px" }}
                    >
                        {
                            isLoading && <IconLoading type='spin' color={'#fff'} />
                        }
                        ذخیره تغییرات
                    </button>
                </div>
            </form>
        </div>
    );
}

export default UserInfo;